import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://jytqrkiapxqkeofhqdjk.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp5dHFya2lhcHhxa2VvZmhxZGprIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODAzOTc1MTQsImV4cCI6MjA5NTk3MzUxNH0.RGeLC_st7v0no4pHW4fV3r-Muw7K2uoVxNdV_wp8J6k';

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: { flowType: 'implicit' },
});